import React from 'react'
import { courses } from '../../utilities/constants'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'

const CoursesList = ({ handleSkillSelection }) => {
    return (
        courses.map((item, index) => (
            <div key={index} className='bg-bg-13/[15%] text-sm font-medium flex items-center rounded-lg pl-2 pr-3 py-2.5 gap-2 cursor-pointer' onClick={() => handleSkillSelection(index)}>
                <img src={item.image} alt="" />
                <p className='flex-1'>{item.name}</p>
                <FontAwesomeIcon icon={faChevronRight} />
            </div>
        ))
    )
}

export default CoursesList